import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountingMigrationRow } from "../utils";

export const SourceCell = memo(function SourceCell({
    row,
}: CellContext<ViewTableFeatures, AccountingMigrationRow, unknown>) {
    return (
        <ViewTableCell>
            {row.original.accountingMigration.externalSystem ?? ""}
        </ViewTableCell>
    );
});
